import React from 'react'
import PropTypes from 'prop-types'

import routes from 'src/lib/rails-routes/rails-routes'
import Card from 'src/ui/Card/Card'
import ToggledStateLabel from 'src/ui/ToggledStateLabel/ToggledStateLabel'
import { usePageParams } from 'src/utils/params'
import { t } from 'src/lib/i18n-react'

import UnitTopicCatalogSkeleton from './UnitTopicCatalogSkeleton'

const UnitTopicCatalog = ({ title, topics }) => {
  const { l2Code } = usePageParams()

  return (
    <UnitTopicCatalogSkeleton
      titleSection={title}
      topicListSection={topics.map(
        ({ id, name, coverImageUrl, countOfUnits, progress }) => {
          const totalCountLabel = t(
            '%{smart_count} Unit |||| %{smart_count} Units',
            {
              smart_count: countOfUnits,
            }
          )
          return (
            <Card
              key={`unitTopic-${id}-${name}`}
              linkUrl={routes.advanced_topic(l2Code, id)}
              imgUrl={coverImageUrl}
              title={name}
              subtitle={
                progress.countOfQueuedUnits > 0 ? (
                  <ToggledStateLabel
                    icon="bookmarked"
                    label={
                      progress.countOfQueuedUnits < countOfUnits
                        ? t('%{countOfQueuedUnits}/%{countOfUnits} Units', {
                            countOfQueuedUnits: progress.countOfQueuedUnits,
                            countOfUnits,
                          })
                        : totalCountLabel
                    }
                    labelVariant="text.subtitle"
                  />
                ) : (
                  totalCountLabel
                )
              }
            />
          )
        }
      )}
    />
  )
}

UnitTopicCatalog.propTypes = {
  title: PropTypes.string.isRequired,
  topics: PropTypes.array.isRequired,
}

export default UnitTopicCatalog
